import { Ban, LogIn, SearchX, ServerCrash, ShieldAlert, Unplug } from "lucide-react";
import type { LucideIcon } from "lucide-react";

import { PortalError } from "../api/client";
import { Alert, AlertDescription, AlertTitle } from "./ui/alert";

/**
 * A run whose evidence failed verification answers with 422 and is reported as
 * tamper evidence, not as a request that went wrong.
 */
const EXPLANATION: Record<number, { icon: LucideIcon; title: string; alarming: boolean }> = {
  0: { icon: Unplug, title: "The portal is unreachable", alarming: true },
  401: { icon: LogIn, title: "Sign in again", alarming: false },
  403: { icon: Ban, title: "Your portal roles do not allow this", alarming: false },
  404: { icon: SearchX, title: "Not in the indexed window", alarming: false },
  422: { icon: ShieldAlert, title: "Stored evidence failed verification", alarming: true },
  502: { icon: ServerCrash, title: "The audit container could not be read", alarming: true },
};

export function ErrorNotice({ error }: { error: Error }) {
  const status = error instanceof PortalError ? error.status : null;
  const explanation = status === null ? undefined : EXPLANATION[status];
  const Icon = explanation?.icon ?? ShieldAlert;
  return (
    <Alert variant={explanation?.alarming === false ? "default" : "destructive"}>
      <Icon />
      <AlertTitle>
        {explanation?.title ?? "The portal could not serve this request"}
      </AlertTitle>
      <AlertDescription>{error.message}</AlertDescription>
    </Alert>
  );
}
